import { render, staticRenderFns } from "./CustomStep.vue?vue&type=template&id=b394d58e&scoped=true"
import script from "./CustomStep.vue?vue&type=script&lang=js"
export * from "./CustomStep.vue?vue&type=script&lang=js"
import style0 from "./CustomStep.vue?vue&type=style&index=0&id=b394d58e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b394d58e",
  null
  
)

export default component.exports